import type { UIStrings } from './en';

export const ko: UIStrings = {
  'site.title': 'DopeJs — AI 네이티브 개발을 위한 오픈소스 도구',
  'site.description':
    'DopeJs는 AI 네이티브 개발을 위한 오픈소스 도구를 만듭니다. 에이전트 런타임, 터미널 코딩 에이전트, CLI 환경 도구, Canvas 렌더링 엔진.',

  'nav.projects': '프로젝트',
  'nav.about': '소개',
  'nav.github': 'GitHub',
  'nav.skip': '본문으로 건너뛰기',
  'nav.theme': '테마',
  'nav.language': '언어',

  'hero.eyebrow': '오픈소스 · 공개 개발',
  'hero.title': 'AI 네이티브 개발을 위한 도구.',
  'hero.body':
    'DopeJs는 하나의 질문을 중심으로 모인 작은 오픈소스 프로젝트 모음입니다. 에이전트가 개발 루프의 일부가 될 때, 매일 쓰는 소프트웨어는 어떤 모습이어야 할까요? 에이전트 런타임, 터미널 코딩 에이전트, CLI 환경 도구, Canvas 렌더링 엔진 — 모두 공개적으로 개발합니다.',
  'hero.cta.projects': '프로젝트 보기',
  'hero.cta.github': 'GitHub에서 보기',
  'hero.count': '개 프로젝트',

  'projects.title': '프로젝트',
  'projects.repo': '저장소',
  'projects.homepage': '웹사이트',
  'projects.install': '설치',
  'projects.copy': '복사',
  'projects.copied': '복사됨',
  'projects.details': '자세히',

  'status.stable': '출시됨',
  'status.active': '활발히 개발 중',
  'status.early': '초기 단계 — 프로덕션에는 부적합',
  'status.design': '설계 단계',

  'project.back': '전체 프로젝트',
  'project.overview': '개요',
  'project.highlights': '무엇을 하나',
  'project.getStarted': '시작하기',
  'project.requirements': '요구 사항',
  'project.facts': '한눈에 보기',
  'project.facts.status': '상태',
  'project.facts.languages': '언어',
  'project.facts.license': '라이선스',
  'project.facts.noLicense': '아직 없음',
  'project.links': '링크',
  'project.issues': 'Issues',
  'project.releases': 'Releases',
  'project.prev': '이전',
  'project.next': '다음',

  'about.title': 'DopeJs 소개',
  'about.body':
    '여기 있는 모든 것은 GitHub에서 공개적으로 개발됩니다. 어느 저장소든 이슈와 풀 리퀘스트를 환영하며, "아직 동작하지 않는다"는 솔직한 제보도 마찬가지로 환영합니다. 일부 프로젝트는 의도적으로 프리릴리스 상태이며, 해당하는 경우 프로젝트가 직접 밝히고 있습니다.',
  'about.cta': 'GitHub에서 조직 팔로우하기',

  'footer.built': 'React와 Vite로 제작. 소스는 GitHub에 있습니다.',
  'footer.rights': 'DopeJs',
  'footer.translations': '번역은 기계 생성입니다 — 수정 제안을 환영합니다.',
};
